'use strict';
const angular = require('angular');

/*@ngInject*/
export function ContactsService($resource) {
  return $resource('/api/contacts/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/contacts/:id/attachments"
    }
  });
}


export default angular.module('conduu.ContactService', [])
  .factory('ContactService', ContactsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/contacts/contacts.service.js